import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

export default class DsbBookingTab extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
  };

  render() {
    const { content } = this.props;

    if (isEmpty(content)) {
      return null;
    }

    const { title, checkmarks, directBookingCta } = content;

    return (
      <section className="booking-form">
        <h2 className="h2">{title}</h2>
        <ul>
          {checkmarks.map((checkmark) => (
            <li key={checkmark}>{checkmark}</li>
          ))}
        </ul>
        <a
          className="btn btn-primary btn-lg btn-arrow btn-gradient btn-shadow"
          href={directBookingCta.link.href}
        >
          <span>{directBookingCta.text.full}</span>
        </a>
      </section>
    );
  }
}
